__turbopack_context__.v({
  "baseHeader": "Header-module-scss-module__ojZ5HG__baseHeader",
  "header": "Header-module-scss-module__ojZ5HG__header",
  "noShadow": "Header-module-scss-module__ojZ5HG__noShadow",
  "transparent": "Header-module-scss-module__ojZ5HG__transparent",
  "viewTemplate": "Header-module-scss-module__ojZ5HG__viewTemplate",
});
